import { Component, Input, OnInit } from '@angular/core';
import { BarChartData } from '../../../models/IBarChartData';

@Component({
  selector: 'ff-double-bar-chart',
  templateUrl: './double-bar-chart.component.html',
  styleUrls: ['./double-bar-chart.component.scss']
})
export class DoubleBarChartComponent implements OnInit {

  constructor() { }

    /**
   * Data to display use the ChartData interface
   * Format: [{name: string, series: ChartData[]}]
   * ChartDate: {name: string, value: number}
   * @internal
   */
     @Input() data: BarChartData[] = [];

      /**
   * Data to display use the ChartData interface
   * Format: [{name: string, series: ChartData[]}]
   * ChartDate: {name: string, value: number}
   * @internal
   */
       @Input() colors: string[] = ['#000000','#000000'];

     /**
      * show or hide the legend
      * Default value: true
      * @internal
      */
     @Input() showLegend: boolean = true;

     /**
      * sets the tile for the legend
      * Default value: empty
      * @internal
      */
      @Input() legendTitle: string = '';

      /**
      * Sets position of the label
      * Options: ['right', 'below']
      * @internal
      */
       @Input() legendPosition: string = 'below';

   /**
    * Defines padding of the bars
    * Default value: true
    * @internal
    */
     @Input() barPadding: number = 10;

     /**
      * Defines padding of each group
      * Default value: 20
      * @internal
      */
     @Input() groupPadding: number = 20;
  
   
     /**
      * show or hide the x axis
      * @internal
      */
   
     @Input() showXAxis: boolean = true;
   
     /**
      * show or hide the y axis
      * @intenal
      */
   
     @Input() showYAxis: boolean = true;
   
     /**
   * show or hide the y axis label
   * Default value: true
   * @internal
   */
   
     @Input() showYAxisLabel: boolean = true;
   
     /**
   * show or hide the x axis label
   * Default value: true
   * @internal
   */
   
     @Input() showXAxisLabel: boolean = true;
   
     /**
   * the x axis label text
   * @internal
   */
   
     @Input() xAxisLabel: string = '';
   
     /**
   * the y axis label text
   * @internal
   */
   
     @Input() yAxisLabel: string = '';

   /**
   * Defines if the bars will have a gradient effect
   * @internal
   */   
  
   @Input() gradient: boolean = false;
   
       /**
   * the y axis label text
   * @internal
   */
   
   @Input() theme: string = '';
   
     /**
      * display a timeline control under the chart.
      * Only available if a the x scale is linear or time
      * Default Value: true
      * @internal
      */
     @Input() timeline: boolean = true;
   
     /**
   * Chart width
   * Default value: 700
   * @internal
   */
   
     @Input() width: number = 700;
   
     /**
   * Chart height
   * Default value: 400
   * @internal
   */
   
     @Input() height: number = 400;
   
     /**
   * Function to execute in the parent component
   * @internal
   */
     @Input() select: Function;
   
     /**
   * Function to execute in the parent component
   * @internal
   */
     @Input() activate: Function;
   
     /**
   * Function to execute in the parent component
   * @internal
   */
     @Input() deactivate: Function;

     colorScheme = {
      domain: []
    }

    chartSize: number[] = [];


    ngAfterViewInit(): void {
    //Change color of legend labels
      setTimeout(() => {
        let elements = Array.from(document.getElementsByClassName('legend-label-text') as HTMLCollectionOf<HTMLElement>);
        elements.forEach(e => {
          let box = e.parentElement.firstChild as HTMLElement;
          let color = box.style.backgroundColor;
          e.setAttribute('style', 'color:' + color);
        });

      
      });
    }

  ngOnInit(): void {
    this.chartSize = [this.width, this.height];
    this.colorScheme.domain = this.colors;
    this.data.forEach(e => {
      e.series[0].color = this.colors[0];
      e.series[1].color = this.colors[1];
    });
  }

}
